import {
  Box,
  Collapse,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Header from "../../common/Header";
import CustomTextField from "../../common/CustomTextField";
import {
  AddCircleOutlineOutlined,
  DeleteOutlineOutlined,
  Description,
  ListAltOutlined,
  ModeOutlined,
  SearchOutlined,
  UploadFileOutlined,
} from "@mui/icons-material";
import Card from "../../common/Card";
import Button from "../../common/Button";
import Table from "../../common/CustomTable";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import CustomDropdownField from "../../common/CustomDropdownFiled";
import { useCallback, useEffect, useMemo, useState } from "react";
import { deleteProductDocument, fetchDocumentList, ProductDocumentListInfo, PublishDocumentRequest, publishProductDocument, SearchDocument, updateElementInDocumentSlice, useDocumentReducer } from "../../../redux/slice/document/DocumentSlice";
import { useForm } from "react-hook-form";
import CustomIconButton from "../../common/CustomIconButton";
import colors from "react-multi-date-picker/plugins/colors";
import { tokens } from "../../../theme";
import DocumentUploadPopup from "./DocumentUploadPopup";
import { fetchProductsByUserRoleData, ProductInfo, useProductListReducer } from "../../../redux/slice/product/productListSlice";
import { fetchManufacturersListUserSlice, useUserReducer } from "../../../redux/slice/userSlice";
import { fetchAppConfigList, ManufacturerInfo, setSingleAlertObj, showHideLoadingDialog, SingleAlertInfo, updateElementInCommonSlice, useCommonReducer } from "../../../redux/slice/commonSlice";
import { getSearchCriteriaFromSessionStorage, setSearchCriteriaToSessionStorage } from "../../../utils/StorageUtils";
import { CAN_ACCESS_APPLICATION, NO, PRODUCT_DOCUMENT_PUBLISH_STATUS, PRODUCT_DOCUMENT_STATUS, PRODUCT_DOCUMENT_TYPES, USER_ROLES, YES } from "../../../constants/applicationConstants";
import { selectIsTokenAvailable, useAuthSlice } from "../../../redux/slice/authSlice";
import { hideElement, sortNames } from "../../../utils/Utility";
import { CodeTable, getCodeTableValuesByTableName, useCodetablesSlice } from "../../../redux/slice/codetableSlice";
import CustomCommentPreview from "../../common/CustomCommentPreview";
import { useNavigation } from "../../../hooks/useNavigation";
import { useFilterPanelFocus } from "../../../hooks/useFilterPanelFocus";
import CustomCommentPopup from "../../common/CustomCommentPopup";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import UpdateProductDocumentStatusPopup from "../product/UpdateProductDocumentStatusPopup";
import { SUCCESS_CODE } from "../../../service/ServiceConstants";
import { updateElementInProductSlice } from "../../../redux/slice/product/createProductSlice";
import OptionsPopup from "../../common/OptionsPopup";
import { useModalStyles } from "../../common/useModalStyles";

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: "right" | "center" | "left";
  format?: (value: number) => string;
}

interface DocumentRow {
  id: number | undefined;
  documentName: string | undefined;
  dateUploaded: string | undefined;
  lastUploaded: string | undefined;
  uploadBy: string | undefined;
  action?: JSX.Element;
}

export type SearchDocumentRequest = {
  productId: number | null;
  manufacturerId: number | null;
  category: string;
  subCategory: string;
  status: string,
  productDocumentStatus?: string[]
  publish: string;
  currentPage: number;
  itemsPerPage: number;
  resourceType: string;
}

const columns: Column[] = [
  { id: "documentType", label: "Resources Type", minWidth: 100 },
  { id: "documentName", label: "Resources Name", minWidth: 200 },
  { id: "productName", label: "Product", minWidth: 200 },
  { id: "manufacturer", label: "Manufacturer", minWidth: 100 },
  { id: "category", label: "Category", minWidth: 250 },
  { id: "subCategory", label: "Sub Category", minWidth: 40 },
  { id: "status", label: "Status", minWidth: 100 },
  // { id: "comments", label: "Comment", minWidth: 75 },
  // { id: "documentURL", label: "Document URL", minWidth: 150, },
   { id: "publish", label: "Publish", minWidth: 150, },
  { id: "action", label: "Action", minWidth: 50 },
];

const ITEMS_PER_PAGE = 20;

const DocumentList = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const { primaryBtnSx, tokens: modalTokens } = useModalStyles();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const { navigate } = useNavigation();
  const dispatch = useAppDispatch();
  const { userInfo } = useAuthSlice();
  const { appConfigList } = useCommonReducer();

  const [showCard, setShowCard] = useState(false);
  const {
    filterPanelRef,
    toggleFilterPanel,
    handleFilterPanelEntering,
    handleFilterPanelEntered,
    handleFilterPanelExited,
  } = useFilterPanelFocus(showCard, setShowCard);
  const [showDocumentPopup, setShowDocumentPopup] = useState<{ show: boolean, productDocumentId: number | null }>({ show: false, productDocumentId: null });
  const [productDocumentTypeMap, setProductDocumentTypeMap] = useState<Record<string, string>>({});
  const { control, handleSubmit, reset, setValue, getValues, watch } = useForm<SearchDocumentRequest>();
  const { productsByUserRole } = useProductListReducer();
  const { manufacturerInfoListUserSlice } = useUserReducer();
  const { searchDocumentList } = useDocumentReducer();
  const { allCodeTablesValuesMap, allCodeTableValueFetchStatus } = useCodetablesSlice();
  const [ categoryList, setCategoryList] = useState<CodeTable[]>([]);
  const [ subCategoryList, setSubCategoryList] = useState<CodeTable[]>([]);
  const [showCommentPopup, setShowCommentPopup] = useState(false);
    const [commentData, setCommentData] = useState<{ title: string; body: string }>({
      title: "",
      body: "",
    });
    const [isEditing, setIsEditing] = useState(false);
    const [statusData, setStatusData] = useState<any>({
      productId: "",
      documentId: "",
      manufacturerId: null,
      status: "",
      documentType: ""
    });
    const canChangeProductDocumentStatus = useSelector((state: RootState) => selectIsTokenAvailable("canChangeProductDocumentStatus")(state));
      const [showUpdateStatusPopup, setUpdateStatusPopup] = useState(false);
      const [originalStatusValue, setOriginalStatusValue] = useState<any>();
    const [ productCategories, setProductCategories ] = useState<Map<string, string[]>>(new Map());
    const [fetchInitDataCompleted, setFetchInitDataCompleted] = useState<boolean>(false);
    const [ documentTypeList, setDocumentTypeList] = useState<CodeTable[]>([]);
  
  const [searchCriteria, setSearchCriteria] = useState<SearchDocumentRequest>({
    productId: null,
    manufacturerId: null,
    category: '',
    subCategory: '',
    status: '',
    publish: '',
    resourceType: '',
    currentPage: 1,
    itemsPerPage: ITEMS_PER_PAGE,
  });

  type Option = {
    value: string | number;
    label: string;
  };

  const documentList: DocumentRow[] = [
    {
      id: 1,
      documentName: "V1Sample Document.pdf",
      dateUploaded: "11/11/2024",
      lastUploaded: "21/11/2024",
      uploadBy: "harsha@gmail.com",
    },
    {
      id: 2,
      documentName: "V2Sample Document.pdf",
      dateUploaded: "12/12/2024",
      lastUploaded: "22/12/2024",
      uploadBy: "madushanka@gmail.com",
    },
    {
      id: 3,
      documentName: "V3Sample Document.pdf",
      dateUploaded: "13/13/2024",
      lastUploaded: "23/13/2024",
      uploadBy: "hm@gmail.com",
    },
  ];

    //mount
    useEffect(() => {
      fetchInitialLists();
    }, []);
      
    const patientBorderColor = isDark ? "rgba(148,163,184,0.2)" : "rgba(15,23,42,0.12)";
  const patientPanelBg = isDark ? "#141720" : "rgba(255,255,255,0.82)";
  const patientSoftBg = isDark ? "rgba(15,23,42,0.35)" : "rgba(248,250,252,0.85)";
  const patientHoverBg = isDark ? "rgba(20,184,166,0.09)" : "rgba(20,184,166,0.06)";

  const patientCardSx = {
    borderRadius: "14px",
    border: `1px solid ${patientBorderColor}`,
    backgroundColor: patientPanelBg,
    backgroundImage: "none",
    backdropFilter: "blur(8px)",
    boxShadow: isDark ? "0 12px 32px rgba(0,0,0,0.28)" : "0 12px 28px rgba(15,23,42,0.08)",
  };

  const filterPanelSx = {
    ...patientCardSx,
    p: { xs: "14px !important", md: "18px !important" },
    "& .MuiAutocomplete-root, & .MuiFormControl-root": {
      width: "100%",
      height: "42px",
      minHeight: "42px !important",
    },
    "& .MuiTextField-root": {
      height: "42px",
      minHeight: "42px !important",
    },
    "& .MuiOutlinedInput-root, & .MuiInputBase-root, & .MuiAutocomplete-inputRoot, & .MuiAutocomplete-root .MuiOutlinedInput-root": {
      minHeight: "42px !important",
      height: "42px !important",
      borderRadius: "10px !important",
      backgroundColor: `${modalTokens.inputBg} !important`,
      color: modalTokens.textPrimary,
      fontSize: "0.88rem",
      boxShadow: isDark ? "none" : "0 1px 3px rgba(0,0,0,0.06)",
      alignItems: "center",
      boxSizing: "border-box",
    },
    "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
      padding: "0 38px 0 12px !important",
    },
    "& .MuiAutocomplete-root .MuiInputBase-input, & .MuiAutocomplete-input, & .MuiOutlinedInput-input": {
      paddingTop: "8px !important",
      paddingBottom: "8px !important",
      height: "24px !important",
      lineHeight: "24px !important",
      boxSizing: "border-box",
    },
    "& .MuiOutlinedInput-input": {
      paddingLeft: "12px !important",
      paddingRight: "12px !important",
    },
    "& .MuiAutocomplete-endAdornment": {
      top: "50% !important",
      transform: "translateY(-50%)",
      right: "8px !important",
    },
    "& .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root fieldset": {
      borderColor: `${modalTokens.inputBorder} !important`,
    },
    "& .MuiOutlinedInput-root:hover fieldset, & .MuiOutlinedInput-root.Mui-focused fieldset": {
      borderColor: `${modalTokens.accent} !important`,
      borderWidth: "1px !important",
    },
    "& .MuiOutlinedInput-root.Mui-focused": {
      boxShadow: isDark ? "none" : "0 0 0 3px rgba(20,184,166,0.12)",
    },
    "& .MuiInputBase-input": {
      color: modalTokens.textPrimary,
      fontSize: "0.88rem",
    },
    "& input::selection": {
      color: modalTokens.textPrimary,
      backgroundColor: isDark ? "rgba(20,184,166,0.28)" : "rgba(20,184,166,0.2)",
    },
    "& .MuiOutlinedInput-root:has(input:-webkit-autofill)": {
      backgroundColor: "#376c9f !important",
      "& fieldset": {
        borderColor: "#7fb1df !important",
      },
    },
    "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus": {
      WebkitTextFillColor: "#ffffff",
      caretColor: "#ffffff",
      WebkitBoxShadow: "0 0 0 100px #376c9f inset",
      borderRadius: "10px",
      transition: "background-color 5000s ease-in-out 0s",
    },
    "& .MuiInputLabel-root": { color: isDark ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.45)", fontSize: "0.88rem" },
    "& .MuiInputLabel-root.Mui-focused": { color: `${modalTokens.accent} !important` },
    "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": { transform: "translate(14px, 9px) scale(1)" },
    "& .MuiChip-root": {
      borderRadius: "999px",
      backgroundColor: isDark ? "rgba(20,184,166,0.16)" : "rgba(20,184,166,0.1)",
      color: modalTokens.accent,
      border: `1px solid ${isDark ? "rgba(20,184,166,0.26)" : "rgba(20,184,166,0.18)"}`,
      fontWeight: 600,
    },
  };

  const patientPrimaryBtnSx = {
    ...primaryBtnSx,
    color: "#fff",
    height: "42px",
    py: 0,
    "& .MuiTypography-root": {
      color: "#fff",
      fontWeight: 700,
    },
    "& .MuiButton-startIcon": {
      color: "#fff",
    },
  };

  const outlineBtnSx = {
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.86rem",
    borderRadius: "10px",
    py: 1.05,
    px: 1.6,
    color: modalTokens.accent,
    borderColor: "rgba(20,184,166,0.55)",
    backgroundColor: isDark ? "rgba(20,184,166,0.08)" : "rgba(20,184,166,0.04)",
    whiteSpace: "nowrap",
    "&:hover": {
      color: "#fff",
      borderColor: modalTokens.accentHover,
      backgroundColor: modalTokens.accentHover,
      boxShadow: "0 6px 22px rgba(20,184,166,0.28)",
    },
  };

  const filterToggleBtnSx = {
    ...outlineBtnSx,
    color: "#00B8D9",
    borderColor: "rgba(0,184,217,0.55)",
    backgroundColor: isDark ? "rgba(0,184,217,0.08)" : "rgba(0,184,217,0.04)",
    "&:hover": {
      color: "#fff",
      borderColor: "#00B8D9",
      backgroundColor: "#00B8D9",
      boxShadow: "0 6px 22px rgba(0,184,217,0.28)",
    },
  };

  const patientTableSx = {
    "& .MuiTableContainer-root": {
      borderRadius: "12px",
      border: "none",
      backgroundColor: "transparent",
    },
    "& table": {
      
      borderCollapse: "collapse",
      borderSpacing: 0,
    },
    "& .MuiTableCell-root": {
      borderBottom: `1px solid ${isDark ? "rgba(148,163,184,0.14)" : "rgba(15,23,42,0.08)"}`,
      py: 1.15,
      fontSize: "0.84rem",
    },
    "& .MuiTableHead-root .MuiTableCell-root": {
      height: "42px",
    },
    "& .MuiTableHead-root .MuiTypography-root": {
      color: "#00B8D9 !important",
      fontSize: "0.78rem",
      fontWeight: 800,
      letterSpacing: "0.02em",
    },
    "& .MuiTableBody-root .MuiTableRow-root": {
      transition: "background-color 0.18s ease, box-shadow 0.18s ease",
    },
    "& .MuiTableBody-root .MuiTableRow-root:hover": {
      backgroundColor: `${patientHoverBg} !important`,
    },
    "& .MuiTableBody-root .MuiTableCell-root, & .MuiTableBody-root .MuiTypography-root": {
      color: modalTokens.textPrimary,
      fontSize: "0.84rem",
    },
    "& .MuiTableBody-root .MuiTableCell-root:first-of-type .MuiLink-root": {
      color: "#00B8D9 !important",
      fontWeight: 600,
      textDecorationColor: "rgba(0,184,217,0.45)",
    },
    "& .MuiTableBody-root .MuiTableCell-root:first-of-type .MuiLink-root:hover": {
      color: "#22d3ee !important",
      textDecorationColor: "#22d3ee",
    },
    "& .MuiIconButton-root": {
      color: isDark ? "#94a3b8" : "#475569",
      borderRadius: "8px",
      "&:hover": {
        color: modalTokens.accent,
        backgroundColor: isDark ? "rgba(20,184,166,0.12)" : "rgba(20,184,166,0.08)",
      },
    },
    "& .MuiPaginationItem-root": {
      borderColor: patientBorderColor,
      color: modalTokens.textSecondary,
      borderRadius: "8px",
      "&.Mui-selected": {
        color: "#fff",
        backgroundColor: modalTokens.accent,
        borderColor: modalTokens.accent,
      },
    },
  };

  const fetchInitialLists = async () => {
    dispatch(showHideLoadingDialog (true ));
    //Don't remove below unused variables
    const responseProduct = await dispatch( fetchProductsByUserRoleData(false) );
    const responseManufacturer = await dispatch( fetchManufacturersListUserSlice() );
    const appConfigList = await dispatch(fetchAppConfigList());

    if(responseProduct && responseManufacturer && appConfigList){
      setFetchInitDataCompleted(true)
    }
    dispatch(showHideLoadingDialog( false ));
  };

  const handleShowDocumentPopup = (prodDocId: number | null) => {
    dispatch(updateElementInDocumentSlice({
      elementName: "productDocumentById",
      value: null
    }));
    dispatch(updateElementInCommonSlice({
      elementName: "documentDataFromCommonApi",
      value: ""
    }));
    setShowDocumentPopup(prev => ({
      show: !prev.show,
      productDocumentId: prodDocId
    }));
  };

    useEffect(() => {
      if (allCodeTableValueFetchStatus === "success" && allCodeTablesValuesMap) {
        const sortedDocumentList = [
          ...getCodeTableValuesByTableName(allCodeTablesValuesMap, "ProductDocument"),
        ].sort((a, b) => a.displayValue.localeCompare(b.displayValue));
        const productDocumentTypeMap = Object.fromEntries(
          sortedDocumentList.map(item => [item.keyName, item.displayValue])
        );
        setProductDocumentTypeMap(productDocumentTypeMap);

        const sortedCategoryList = [
          ...getCodeTableValuesByTableName(allCodeTablesValuesMap, "ProductCategory"),
        ].sort((a, b) => a.displayValue.localeCompare(b.displayValue));
        setCategoryList(sortedCategoryList);

        const sortedSubCategoryList = [
          ...getCodeTableValuesByTableName(allCodeTablesValuesMap, "ProductSubCategory"),
        ].sort((a, b) => a.displayValue.localeCompare(b.displayValue));
        setSubCategoryList(sortedSubCategoryList);

        const sortedResourceTypeList = [
          ...getCodeTableValuesByTableName(allCodeTablesValuesMap, "ProductDocument"),
        ].sort((a, b) => a.displayValue.localeCompare(b.displayValue));
        setDocumentTypeList(sortedResourceTypeList);

      }
    }, [allCodeTablesValuesMap, allCodeTableValueFetchStatus]);

  const categoryListOptions = useMemo(() => {
    return categoryList.map(item => ({
      label: item.displayValue,
      value: item.keyName
    }));
  }, [categoryList]);

  const subCategoryListOptions = useMemo(() => {
    const category = getValues('category');
    
    if (category) {
      const selectedSubCategoryList = productCategories.get(category);
      return selectedSubCategoryList?.map((item: string) => ({
        label: item,
        value: item,
      }));
    } else {
      return subCategoryList.map(subCategory => ({
        label: subCategory.displayValue,
        value: subCategory.keyName,
      }));
    }

  }, [subCategoryList, watch('category')]);

  useEffect(() => {
    if(!appConfigList?.length) return;
      const productCategoryConfig = appConfigList.find(config => config.configName === 'product.document.category.sequence');
      if(productCategoryConfig) {
        const productCategoryConfigValue = JSON.parse(productCategoryConfig.configValue);
        const productCategoriesObj = productCategoryConfigValue.categoryAndSubCategoryList || {};
        const typedEntries = Object.entries(productCategoriesObj).map(
          ([key, value]): [string, string[]] => {
            if (Array.isArray(value) && value.every(item => typeof item === 'string')) {
              return [key, value as string[]];
            }
            return [key, []];
          }
        );
        setProductCategories(new Map(typedEntries))
    }
  }, [appConfigList]);

  //Unmount
  useEffect(
    () => () => {
      dispatch(updateElementInDocumentSlice({
        elementName: 'searchDocumentList',
        value: null
      }));
    },
    []
  );

  const productOptions = useMemo(() => {
    let options: Option[] = [];
    if (productsByUserRole && productsByUserRole.length > 0) {
      if (productsByUserRole.length === 1) {
        setValue('productId', Number(productsByUserRole[0]?.productId));
      }
      const sortedProductList: ProductInfo[] = sortNames(productsByUserRole, 'productName');
      sortedProductList?.map((option) => {
        options.push({ label: option.productName, value: option.productId })
      });
    };
    return options;
  }, [productsByUserRole]);

    const manufacturersList = useMemo(() => {
      let options: Option[] = [];
      if (manufacturerInfoListUserSlice && manufacturerInfoListUserSlice.length > 0) {
        const sortedInfo: ManufacturerInfo[] = sortNames(manufacturerInfoListUserSlice, 'manufacturerName');
        sortedInfo?.map(option => {
          options.push({ label: option.manufacturerName, value: option.manufacturerId });
        });
      }
      return options;
    }, [manufacturerInfoListUserSlice]);

  const documentStatusOpts = [
    { label: PRODUCT_DOCUMENT_STATUS.PENDING, value: PRODUCT_DOCUMENT_STATUS.PENDING },
    { label: PRODUCT_DOCUMENT_STATUS.FEEDBACK, value: PRODUCT_DOCUMENT_STATUS.FEEDBACK },
    { label: PRODUCT_DOCUMENT_STATUS.DEV, value: PRODUCT_DOCUMENT_STATUS.DEV },
    { label: PRODUCT_DOCUMENT_STATUS.STAGE, value: PRODUCT_DOCUMENT_STATUS.STAGE },
    { label: PRODUCT_DOCUMENT_STATUS.LIVE, value: PRODUCT_DOCUMENT_STATUS.LIVE },
    { label: PRODUCT_DOCUMENT_STATUS.INACTIVE, value: PRODUCT_DOCUMENT_STATUS.INACTIVE },
  ];

  const documentPublishOpts = [
    { label: PRODUCT_DOCUMENT_PUBLISH_STATUS.PUBLISHED, value: YES },
    { label: PRODUCT_DOCUMENT_PUBLISH_STATUS.NOT_PUBLISHED, value: NO }
  ];

  const statusUpdateDocumentTypes = [
    PRODUCT_DOCUMENT_TYPES.IVR_FORM,
    PRODUCT_DOCUMENT_TYPES.ORDER_FORM,
    PRODUCT_DOCUMENT_TYPES.SERVICE_AGREEMENT,
    PRODUCT_DOCUMENT_TYPES.TISSUE_TRACKING_FORM,
    PRODUCT_DOCUMENT_TYPES.RETURN_FORM
  ];

  const resourceTypeOpts = useMemo(() => {
    return documentTypeList.map(item => ({
      label: item.displayValue,
      value: item.keyName
    }));
  }, [documentTypeList]);

    useEffect(() => {
      //1. When login another user pagination is remain in the history and can redirect that page
      let criteria = getSearchCriteriaFromSessionStorage(CAN_ACCESS_APPLICATION.DOCUMENT_MANAGEMENT + "SearchCriteria" + userInfo.userId);
      if ((location.state && location.state.documentListSearchCriteria) || (location.state && location.state.withSearchHistory && criteria)) {
        if (location.state && location.state.withSearchHistory) {
          //Below navigate line call back to this useEffect - This for refreshing issue when navigate with state.withSearchHistory=true
          navigate("/resource_list", { state: { documentListSearchCriteria: criteria } });
          return;
        }
        let searchCriteria: SearchDocumentRequest = {
          productId: null,
          manufacturerId: null,
          category: '',
          subCategory: '',
          status: '',
          publish: '',
          resourceType: '',
          currentPage: 0,
          itemsPerPage: 0
        };
        if (location.state && location.state.documentListSearchCriteria) {
          searchCriteria = location.state.documentListSearchCriteria;
        } else {
          searchCriteria = criteria ? criteria : searchCriteria;
        }
        setSearchCriteria(searchCriteria);
        setValuesToCriteriaFields(searchCriteria);
        searchDocument(searchCriteria);
      } else {
        if (userInfo.userRole !== USER_ROLES.ROLE_PRACTICE_USER_PRU) {
          loadInitialDocumentList(1);
        }
      }
    }, [location.state]);

      const loadInitialDocumentList = (pNumber: number = 1) => {
        let data : SearchDocumentRequest = {
          productId: null,
          manufacturerId: null,
          category: "",
          subCategory: "",
          status: "",
          publish: "",
          resourceType: '',
          currentPage: pNumber,
          itemsPerPage: ITEMS_PER_PAGE,
        }
        setSearchCriteria(data);
        setValuesToCriteriaFields(data);
        
        searchDocument(data);
      }

  const setValuesToCriteriaFields = (searchCriteria: SearchDocumentRequest) => {
    setValue("productId", searchCriteria.productId);
    setValue("manufacturerId", searchCriteria.manufacturerId);
    setValue("category", searchCriteria.category);
    setValue("subCategory", searchCriteria.subCategory);
    setValue("status", searchCriteria.status);
    setValue("publish", searchCriteria.publish);
  }

  const searchDocument = (searchCriteria: SearchDocumentRequest) => {
    setSearchCriteriaToSessionStorage(CAN_ACCESS_APPLICATION.DOCUMENT_MANAGEMENT + "SearchCriteria" + userInfo.userId, searchCriteria);
    dispatch(fetchDocumentList(searchCriteria));
  };

  const commentComponent = useCallback((row: ProductDocumentListInfo) => {
    return (<>
      <Grid item>
        {
          row.comments ?
            <CustomCommentPreview
              title={`Comment`}
              commentBody={(row.comments).toString()}
            /> : "N/A"}
      </Grid>
    </>)
  }, [searchDocumentList]);

  const URLComponent = useCallback((row: ProductDocumentListInfo) => {
    const url = typeof row.productDocumentInfo?.documentURL === "string" ? row.productDocumentInfo?.documentURL : null;
  
    if (!url) {
      return null;
    }
  
    return (
      <>
        <Grid>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline", color: colors.info[300] }}
          >
            {url.length > 30 ? `${url.substring(0, 30)}...` : url}
          </a>
        </Grid>
      </>
    );
  }, [colors.info]);

  const renderStatusComponent = (productDocument : ProductDocumentListInfo) => {
    if (canChangeProductDocumentStatus && isEditing && productDocument?.status) {
      return (
        <>
          <CustomDropdownField
            name={`productDocumentStatus.status${productDocument?.documentId}`}
            control={control}
            onChangeSelect={(data) => {

              const inputData = data?.value;
              if (inputData !== statusData.status) {
                setStatusData({  
                  status: inputData, 
                  productId: productDocument?.productId , 
                  manufacturerId: productDocument?.manufacturerId, 
                  documentType: productDocument?.documentType, 
                  documentId: productDocument?.documentId });
                  
                setUpdateStatusPopup(true);
              }
            }}
            options={documentStatusOpts || []}
          />
        </>
      );
    } else {
      return productDocument?.status;
    }
  };

  const productDocumentRows: ProductDocumentListInfo[] = useMemo(() => {
    const rows: ProductDocumentListInfo[] = []
    searchDocumentList?.content?.forEach(pd => {
      const row = {
        ...pd,
        documentType: productDocumentTypeMap[pd.documentType],
        publish: pd.publish ? PRODUCT_DOCUMENT_PUBLISH_STATUS.PUBLISHED : PRODUCT_DOCUMENT_PUBLISH_STATUS.NOT_PUBLISHED,
        manufacturer: pd.manufacturerName || "",
        status: statusUpdateDocumentTypes.includes(pd.documentType) ?
        (  
          statusData.documentId === pd.documentId ?
          (pd.status && renderStatusComponent(pd)) :
          (
            <span
              onClick={() => {
                //@ts-ignore
                setValue(`productDocumentStatus.status${pd.documentId}`, pd.status)
                setStatusData({
                  productId: pd.productId,
                  documentId: pd.documentId, 
                  status: pd.status && (pd.status).toString(), 
                  manufacturerId: pd.manufacturerId,
                  documentType: pd.documentType
                });
                setIsEditing(true); 
                setOriginalStatusValue(pd.status);
              }}
              style={{ cursor: "pointer", display: "inline-block" }}
            >
              {pd.status && (pd.status).toString()}
            </span>
          )
        ) : <span>{pd.status && (pd.status).toString()}</span>
      }
      rows.push(row);
    })
    return rows;
  }, [URLComponent, commentComponent, searchDocumentList]);

  const setCommentPopupEnable = (row: ProductDocumentListInfo) => {
    const title = `Comment`; 
    const body = (row?.comments?.toString()) || "No Comments";
    setCommentData({ title, body });
    setShowCommentPopup(true);
  }

  const publishDocument = async (row: ProductDocumentListInfo) => {
    const publishDocumentRequest: PublishDocumentRequest = {
      productDocumentId: row.productDocumentId,
      publish: row.publish === PRODUCT_DOCUMENT_PUBLISH_STATUS.PUBLISHED ? false : true
    }
    const response = await dispatch(publishProductDocument(publishDocumentRequest));
    if (response?.payload === SUCCESS_CODE) {
      let successObj: SingleAlertInfo = {
        message: `Document ${row.publish === PRODUCT_DOCUMENT_PUBLISH_STATUS.PUBLISHED ? 'unpublished' : 'published'} successfully`,
        alertType: "success",
      };
      dispatch(setSingleAlertObj(successObj));
      dispatch(updateElementInProductSlice({
        elementName: "publishDocumentStatus",
        value: 'idle'
      }));
      navigate("/resource_list", { state: { withSearchHistory: true } });
    }
  };

  const [deleteConfirm, setDeleteConfirm] = useState<{message:string, show: boolean, productDocId: number | null}>({message: "", show: false, productDocId: null});

  const deleteProdDocument = (productDocId: number) => {
    setDeleteConfirm({ message: "Are you sure you want to delete this Product Document?", show: true, productDocId: productDocId });
  }

    const confirmDeleteProductDocument = async () => {
      const response = await dispatch(deleteProductDocument(deleteConfirm.productDocId || 0));
      if (response.payload === SUCCESS_CODE) {
        const alertObj: SingleAlertInfo = {
          message: `Product document has been deleted successfully.`,
          alertType: "success",
        };
        dispatch(setSingleAlertObj(alertObj));
        cancelDeleteProductDocument();
        navigate("/resource_list", { state: { withSearchHistory: true } });
      }
    }

    const cancelDeleteProductDocument = () => {
      setDeleteConfirm({ message: "", show: false, productDocId: null });
    }

  const actionComponent = (row: ProductDocumentListInfo): JSX.Element => {
    return (
      <>
        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Comment"
          color="info"
          size="small"
          variant="outlined"
          onClick={() => setCommentPopupEnable(row)}
          style={{ display: `${hideElement(row.comments === null)}` }}
        >
          <ListAltOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage={row.publish === PRODUCT_DOCUMENT_PUBLISH_STATUS.PUBLISHED ? "Unpublish" : "Publish"}
          color="warning"
          size="small"
          variant="outlined"
          onClick={() => publishDocument(row)}
        >
          <ListAltOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Edit"
          color="info"
          size="small"
          variant="outlined"
          onClick={async () => {handleShowDocumentPopup(row.productDocumentId)}}
        >
          <ModeOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Delete"
          color="error"
          size="small"
          variant="outlined"
          onClick={() => deleteProdDocument(row.productDocumentId)}
        >
          <DeleteOutlineOutlined fontSize="small" />
        </CustomIconButton>
      </>
    );
  };

  const handlePagination = (pageNumber: number) => {
    const data = {
      ...searchCriteria,
      currentPage: pageNumber + 1
    }
    setSearchCriteria(data);
    navigate("/resource_list", { state: { documentListSearchCriteria: data } });
  }

  const onSubmit = (data: SearchDocumentRequest) => {
    setSearchCriteria(data);
    navigate("/resource_list", { state: { documentListSearchCriteria: data } });
  };

  const hideCustomCommentPopup = () =>{
    setShowCommentPopup(false);
    setCommentData({title: "", body: ""})
  };

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          px: { xs: 1, md: 3 },
          py: 2,
        }}
      >
        <Box>
          <Collapse in={showCard} ref={filterPanelRef} onEntering={handleFilterPanelEntering} onEntered={handleFilterPanelEntered} onExited={handleFilterPanelExited}>
            <Card sx={filterPanelSx}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item md={3} xs={12}>
                    <CustomDropdownField 
                      control={control}
                      name="productId"
                      label="Product"
                      options={productOptions}
                      size="small"
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomDropdownField
                      control={control}
                      name="manufacturerId"
                      label="Manufacturer"
                      options={manufacturersList}
                      size="small"
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomDropdownField
                      control={control}
                      name="category"
                      label="Category"
                      options={categoryListOptions || []}
                      size="small"
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomDropdownField
                      control={control}
                      name="subCategory"
                      label="Sub Category"
                      options={subCategoryListOptions || []}
                      size="small"
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomDropdownField
                      control={control}
                      name="status"
                      label="Status"
                      options={documentStatusOpts || []}
                      size="small"
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomDropdownField
                      control={control}
                      name="publish"
                      label="Publish"
                      options={documentPublishOpts || []}
                      size="small"
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomDropdownField
                      control={control}
                      name="resourceType"
                      label="Resource Type"
                      options={resourceTypeOpts || []}
                      size="small"
                    />
                  </Grid>

                  <Grid item md={2} xs={12}>
                    <Button
                      fullWidth
                      size="large"
                      startIcon={<SearchOutlined />}
                      sx={{ ...patientPrimaryBtnSx, height: "42px", py: 0 }}
                      type="submit"
                      removeUpperCase
                    >
                      Search
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Card>
          </Collapse>
        </Box>

        <Box mt={2}>
          <Card sx={{ ...patientCardSx, p: { xs: "14px !important", md: "18px !important" } }}>
            <Grid container justifyContent="space-between" alignItems="center" spacing={1.2}>
              <Grid item xs={12} md>
                <Typography variant='h3' fontWeight={800} color="text.primary">
                  Resource List
                </Typography>
              </Grid>

              <Grid item xs={12} md="auto">
                <Button
                  variant="outlined"
                  color="info"
                  onClick={toggleFilterPanel}
                  startIcon={<SearchOutlined />}
                  fullWidth
                  sx={filterToggleBtnSx}
                  removeUpperCase
                >
                  {showCard ? "Hide Filters" : "Show Filters"}
                </Button>
              </Grid>

              <Grid item xs={12} md="auto">
                <Button
                  color="info"
                  startIcon={<UploadFileOutlined />}
                  fullWidth
                  onClick={() => handleShowDocumentPopup(null)}
                  sx={patientPrimaryBtnSx}
                  removeUpperCase
                >
                  Upload Resources
                </Button>
              </Grid>
            </Grid>
            <Table
              columns={columns}
              rows={fetchInitDataCompleted ? productDocumentRows || [] : []}
              pageNumber={handlePagination}
              totalPages={fetchInitDataCompleted ? searchDocumentList?.totalPages : 0}
              actionComponent={actionComponent}
              totalElementText={"Records: " + ((fetchInitDataCompleted && searchDocumentList?.totalElements) ? searchDocumentList?.totalElements : "0")}
              currentPageNumber={searchCriteria.currentPage - 1}
              emptyText="No Documents Found"
              showMenu={true}
              sx={patientTableSx}
            />
          </Card>
        </Box>
      </Box>

     {showDocumentPopup?.show && <DocumentUploadPopup
        onClose={() => handleShowDocumentPopup(null)}
        open = {showDocumentPopup?.show}
        productDocumentId = {showDocumentPopup?.productDocumentId} 
      />}
      {showCommentPopup &&
        <CustomCommentPopup
          open={showCommentPopup}
          onClose={hideCustomCommentPopup}
          title={commentData?.title || "Comment"}
          commentBody={commentData.body}
        />
      }
      {showUpdateStatusPopup && (
        <UpdateProductDocumentStatusPopup
          open={showUpdateStatusPopup}
          statusData={statusData}
          originalStatusValue={originalStatusValue}
          onClose={() => {
            setUpdateStatusPopup(false);
            setIsEditing(false);
            setStatusData("");
          }}
          navigateFrom={'/resource_list'}
        />
      )}
      {deleteConfirm.show &&
        <OptionsPopup
          open={deleteConfirm.show}
          onClose={() => setDeleteConfirm({ message: "", show: false, productDocId: null })}
          variant="confirm"
          message={<>{deleteConfirm.message}</>}
          buttons={[{ name: "Confirm", color: 'primary', onClick: confirmDeleteProductDocument }, { name: "Cancel", color: 'secondary', onClick: cancelDeleteProductDocument }]}
        />
      }
    </>
  );
};

export default DocumentList;
